<template>
    <v-container fluid fill-height class="home-hero" style="max-height: 100vh">
        <v-layout justify-center align-center column pa-5>
            <div
              
            ><img src="../assets/images/LogoCAMON_alpha.png" width="300px"></div>
            <div
                class="white--text text-xs-center"
                style="background-color: black"
            >
                Video personalizzati delle tue imprese sportive.
            </div>
            <!--v-btn fab class="mt-5 red darken-4">
                <v-icon large color="white">expand_more</v-icon>
            </v-btn-->
        </v-layout>
    </v-container>
</template>

<script>
export default {
    name: 'HomeHero',
};
</script>

<style scoped>
.home-hero {
    background: url('../assets/images/tri.jpg');
    background-size: cover;
    width: 100%;
    height: 25%;
}
</style>
